import React, { useState, useEffect, useMemo } from "react";

const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // 🔹 Keep HIGH video quality (no eco compression)
  const videoUrls = useMemo(
    () => ({
      mobile:
        "https://res.cloudinary.com/ddvpczzng/video/upload/f_auto:video,q_auto/v1765915372/main_vdo_jcualh",
      desktop:
        "https://res.cloudinary.com/ddvpczzng/video/upload/f_auto:video,q_auto/v1765910025/M_ouc2eo",
    }),
    []
  );

  useEffect(() => {
    if (typeof document === "undefined") return;
    const videoUrl = isMobile ? videoUrls.mobile : videoUrls.desktop;

    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "video";
    link.href = `${videoUrl}.mp4`;
    link.crossOrigin = "anonymous";

    document.head.appendChild(link);
    return () =>
      document.head.contains(link) && document.head.removeChild(link);
  }, [isMobile, videoUrls]);

  const videoSrc = isMobile ? videoUrls.mobile : videoUrls.desktop;

  return (
    <section
      id="home"
      aria-label="School Hero Section"
      className="relative w-full h-[100dvh] min-h-[600px] overflow-hidden flex items-center justify-center"
    >
      <div
        className="absolute inset-0 z-0 bg-gradient-to-br from-slate-800 to-slate-900"
        aria-hidden="true"
      >
        <div
          className={`absolute inset-0 transition-opacity duration-500 ${
            videoLoaded ? "opacity-0" : "opacity-100"
          }`}
        />

        <video
          key={isMobile ? "mobile" : "desktop"}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover motion-reduce:hidden"
          poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%230f172a'/%3E%3C/svg%3E"
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src={`${videoSrc}.mp4`} type="video/mp4" />
          <source src={`${videoSrc}.webm`} type="video/webm" />
        </video>

        <div className="absolute inset-0 hidden motion-reduce:block bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/40 to-black/80 z-10 pointer-events-none" />

      <div className="absolute bottom-4 left-4 z-20">
        <div className="relative">
          <div className="absolute -inset-1 bg-cyan-600 rounded-lg opacity-70 blur-sm animate-pulse" />
          <div className="relative px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
            <span className="text-white text-sm sm:text-base font-medium tracking-wide">
              Arise and Shine
            </span>
          </div>
        </div>
      </div>

      <div className="absolute top-20 left-10 w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-cyan-400/20 blur-xl animate-[float_8s_ease-in-out_infinite]" />
      <div className="absolute bottom-1/3 right-10 w-16 h-16 sm:w-24 sm:h-24 rounded-full bg-white/10 blur-xl animate-[float_10s_ease-in-out_infinite_reverse]" />
    </section>
  );
};

export default React.memo(HeroSection);
